import axios from 'axios';

import { logout } from '@redux/actions/User';

const axiosUtil = {
  initalise: (store) => {
    axios.defaults.baseURL = process.env.REACT_APP_BASEURL;
    axios.interceptors.request.use(
      (axiosConfig) => {
        axiosConfig.headers['Content-Type'] = 'application/json';

        const token = localStorage.getItem('token');
        if (token) {
          axiosConfig.headers.Authorization = `Bearer ${token}`;
        }

        return axiosConfig;
      },
      (error) => {
        Promise.reject(error);
      },
    );
    // Response Interceptor - logout the user if the api sends a request to do that
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      function (error) {
        if (error?.response?.data?.is_logout === 1) {
          store.dispatch(logout({ queryClient: undefined }));
        }
        return Promise.reject(error);
      },
    );
  },
};

export default axiosUtil;
